export default "__VITE_ASSET__By4Qdq_1__"